interface Props {
  memory: string[];
  onClear: () => void;
}
const MemoryPanel: React.FC<Props> = ({ memory, onClear }) => (
  <div className="memory-section">
    <h3>Memory</h3>
    <button className="clear-memory" onClick={onClear}>Clear</button>
    {memory.map((item, idx) => (
      <div key={idx} className="memory-item">{item}</div>
    ))}
  </div>
);
export default MemoryPanel;
